import { render, staticRenderFns } from "./DesignOppositionOwnerList.vue?vue&type=template&id=ec7fe80e&"
import script from "./DesignOppositionOwnerList.vue?vue&type=script&lang=js&"
export * from "./DesignOppositionOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./DesignOppositionOwnerList.vue?vue&type=style&index=0&id=ec7fe80e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports